/**
 * @flow
 * @relayHash 75b8660d7b31766c78aec4160113002b
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type Footer_viewer$ref = any;
export type footerRootQueryVariables = {|
  userId?: ?string,
  hasUserId: boolean,
|};
export type footerRootQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: Footer_viewer$ref
  |}
|};
export type footerRootQuery = {|
  variables: footerRootQueryVariables,
  response: footerRootQueryResponse,
|};
*/


const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "hasUserId",
    "type": "Boolean!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "footerRootQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "Footer_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "footerRootQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": "isSiteMapsEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "HTML_SITE_MAPS",
                "type": "String!"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"HTML_SITE_MAPS\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isTradeExperienceEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "TRADE_EXPERIENCE",
                "type": "String!"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"TRADE_EXPERIENCE\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isAboutUsPageEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "ABOUT_US_PAGE",
                "type": "String!"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"ABOUT_US_PAGE\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isCareersPageEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "CAREERS_PAGE",
                "type": "String!"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"CAREERS_PAGE\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isPressPageEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "PRESS_PAGE",
                "type": "String!"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"PRESS_PAGE\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isQuestionsPageEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "QUESTIONS_PAGE",
                "type": "String!"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"QUESTIONS_PAGE\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isSellerApplicationEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "SELLER_APPLICATION",
                "type": "String!"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"SELLER_APPLICATION\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isDownloadAppEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "DOWNLOAD_APP",
                "type": "String!"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"DOWNLOAD_APP\")"
          },
          {
            "kind": "ScalarField",
            "alias": "doNotShowPrivacyPolicyAlerts",
            "name": "isEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "doNotShowPrivacyPolicyAlerts",
                "type": "String!"
              }
            ],
            "storageKey": "isEnabled(key:\"doNotShowPrivacyPolicyAlerts\")"
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "currencies",
            "args": null,
            "storageKey": null
          },
          (v1/*: any*/),
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasUserId",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "user",
                "storageKey": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "userId",
                    "variableName": "userId",
                    "type": "String!"
                  }
                ],
                "concreteType": "User",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "serviceId",
                    "args": null,
                    "storageKey": null
                  },
                  (v1/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "profile",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Profile",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "currency",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "footerRootQuery",
    "id": "dibs-buyer-layout/222.6.0-2019-06-25T11:58:43.302Z/footerRootQuery",
    "text": null,
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e23c6ccf9fbba02833d741b37d565542';
module.exports = node;
